import React from "react";
import "./index.css";
import ContactForm from "./ContactForm";

function Contact() {
  return (
    <section className="detail-page">
      <div className="detail-container">
        <h1 className="detail-title">
          Get in <span className="detail-gradient">Touch</span>
        </h1>

        <div className="detail-intro">
          <p>
            Please contact us to discover how we can help your business!
          </p>
        </div>

        <div className="contact-grid">
          <div className="contact-form-wrap">
            <ContactForm />
          </div>

          <div className="contact-info-wrap">
            <div className="detail-card">
              <div className="detail-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <h2 className="detail-card-title">Location</h2>
              <p className="contact-detail-text">Conncepts Consulting</p>
              <p className="contact-detail-text">Spring Hill, FL</p>
            </div>

            <div className="detail-card detail-card-accent">
              <div className="detail-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <h2 className="detail-card-title">Email</h2>
              <p className="contact-detail-text">
                <a href="mailto:sales@conncepts.pro" className="contact-link">sales@conncepts.pro</a>
              </p>
            </div>

            <div className="detail-card">
              <div className="detail-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
              </div>
              <h2 className="detail-card-title">Phone</h2>
              <p className="contact-detail-text">
                <a href="tel:8133361662" className="contact-link">813-336-1662</a>
              </p>
            </div>

            <a href="/pricing" className="contact-pricing-btn">View Pricing Options</a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
